const compareReducer = (state = 0, action) => {
    switch (action.type) {
        case 'COMPARE':
            return state + 1;
        default:
            return state
    }
}
export default compareReducer
